import Services from "./services/Services";
import PageLayout from "../../pages/PageLayout";
import { useAuth } from "../../contexts/AuthContext";

const Home = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div>Loading...</div>;
  }
  if (!user) {
    return <div>Please sign in to access this page.</div>;
  }

  return <Services />;
};

export default Home;
